import React from "react";
import { useSelector } from "react-redux";
import { useState, useEffect } from "react";
import useSnackbar from "../../../hooks/useSnackbar";
import AgGridPaginatedTable from "../../../components/AgGridPaginatedTable";
import { salesOrderItemsTable1 } from "../../../config/grid-column-defs";
import { getTransactionItems } from "../../../api/transaction-type";
import { slugMap } from "../../../config/slug-config";
import { useParams } from "react-router-dom";
import {
  Box,
  Checkbox,
  CircularProgress,
  FormControlLabel,
  FormGroup,
  Grid,
} from "@mui/material";

export default function SalesOrderItems({ setItemSum }) {
  const snackbar = useSnackbar();
  const { data: user } = useSelector((state) => state.user);
  const params = useParams();
  const [loading, setLoading] = useState(false);
  const pageDetail = slugMap[params.slug];
  const [rowData, setRowData] = useState([]);
  async function getTransactionItemsData(limit, offset) {
    setLoading(true);
    try {
      const { data } = await getTransactionItems(user.token, {
        id: params.docNo,
        limit,
        offset,
      });
      setItemSum(data.data.itemsum);
      setRowData(data.data);
      setLoading(false);
      return {
        rows: data.data.items,
        total: data.data.itemstotal,
        error: false,
      };
    } catch (error) {
      console.log(error);
      setLoading(false);
      snackbar.showError("Error In Loading Data.");
      return { error: true };
    } finally {
      setLoading(false);
    }
  }

  return (
    <>
      <Box className="viewDetilsBox">
        <Grid container className="mb-2">
          {/* <Grid item xs={12} sm={6} className="m-b-10">
            <p className="tFormlabel">MISSING SEGMENT REVIEW</p>
            <p className="tFormName">{rowData?.missing_segment_review}</p>
          </Grid> */}
          {/* <Grid item xs={12} sm={6} className="m-b-10">
            <p className="tFormlabel">IS REJECTED</p>
            <p className="tFormName">{rowData?.is_rejected}</p>
            
          </Grid> */}

          {/* <Grid item xs={12} sm={6} className="m-b-10">
            <p className="tFormlabel">
              <FormGroup>
                {rowData.is_rejected === "F" || rowData.is_rejected === "" ? (
                  <FormControlLabel
                    control={<checkbox  disabled/>}
                    label="IS REJECTED"
                  />
                ) : (
                  <FormControlLabel
                    control={<Checkbox checked />}
                    label="IS REJECTED"
                  />
                )}
              </FormGroup>
            </p>
          </Grid> */}

          {/* <Grid item xs={12} sm={6} className="m-b-10">
            <p className="tFormlabel">CONTRACT</p>
            <p className="tFormName">{rowData?.contract}</p>
          </Grid> */}
          {/* <Grid item xs={12} sm={6} className="m-b-10">
            <p className="tFormlabel">REJECTED REASON</p>
            <p className="tFormName">{rowData?.missing_segment_review}</p>
            <p className="tFormName">TAX AMOUNT OVERRIDE</p>
            <p className="tFormName">TAX DATE OVERRIDE</p>
          </Grid> */}
          {/* <Grid item xs={12} sm={6} className="m-b-10">
            <p className="tFormlabel">CONTRACT START DATE</p>
            <p className="tFormName">{rowData?.contract_start_date}</p>
          </Grid> */}
          {/* <Grid item xs={12} sm={6} className="m-b-10"> */}
          {/* <p className="tFormlabel">AVATAX OVERRIDE DATE</p>
            <p className="tFormName">{rowData?.avatax_override_date}</p> */}
          {/* </Grid> */}
          <Grid item xs={12} sm={6} className="m-b-10">
            <p className="tFormlabel">DISCOUNT ITEM</p>
            <p className="tFormName">{rowData?.discount_item}</p>
          </Grid>
          <Grid item xs={12} sm={6} className="m-b-10">
            <p className="tFormlabel">
              <FormGroup>
                {rowData.tax_date_override === "F" ||
                rowData.tax_date_override === "" ? (
                  <FormControlLabel
                    control={<checkbox  disabled/>}
                    label="TAX DATE OVERRIDE"
                  />
                ) : (
                  <FormControlLabel
                    control={<Checkbox checked />}
                    label="TAX DATE OVERRIDE"
                  />
                )}
              </FormGroup>
            </p>
          </Grid>
          <Grid item xs={12} sm={6} className="m-b-10">
            <p className="tFormlabel">RATE</p>
            <p className="tFormName">{rowData?.rate}</p>
          </Grid>
          <Grid item xs={12} sm={6} className="m-b-10">
            <p className="tFormlabel">AVATAX OVERRIDE DATE</p>
            <p className="tFormName">{rowData?.avatax_override_date}</p>
          </Grid>
          <Grid item xs={12} sm={6} className="m-b-10">
            <p className="tFormlabel">
              <FormGroup>
                {rowData.tax_override === "F" || rowData.tax_override === "" ? (
                  <FormControlLabel
                    control={<checkbox  disabled/>}
                    label="TAX OVERRIDE"
                  />
                ) : (
                  <FormControlLabel
                    control={<Checkbox checked />}
                    label="TAX OVERRIDE"
                  />
                )}
              </FormGroup>
            </p>
          </Grid>

          {/* <Grid item xs={12} sm={6}></Grid>
          <Grid item xs={12} sm={6} className="m-b-10">
            <p className="tFormlabel">
              <FormGroup>
                {rowData.tax_date_override === "F" ||
                rowData.tax_date_override === "" ? (
                  <FormControlLabel
                    control={<checkbox  disabled/>}
                    label="TAX DATE OVERRIDE"
                  />
                ) : (
                  <FormControlLabel
                    control={<Checkbox checked />}
                    label="TAX DATE OVERRIDE"
                  />
                )}
              </FormGroup>
            </p>
          </Grid>
          <Grid item xs={12} sm={6} className="m-b-10">
            <p className="tFormlabel">AVATAX OVERRIDE DATE</p>
            <p className="tFormName">{rowData?.avatax_override_date}</p>
          </Grid>
          <Grid item xs={12} sm={6}></Grid>
          <Grid item xs={12} sm={6} className="m-b-10">
            <p className="tFormlabel">
              <FormGroup>
                {rowData.generate_invoice === "F" ||
                rowData.generate_invoice === "" ? (
                  <FormControlLabel
                    control={<checkbox  disabled/>}
                    label="GENERATE INVOICE"
                  />
                ) : (
                  <FormControlLabel
                    control={<Checkbox checked />}
                    label="GENERATE INVOICE"
                  />
                )}
              </FormGroup>
            </p>
          </Grid> */}
          {/* <Grid item xs={12} sm={6} className="m-b-10">
            <p className="tFormlabel">GENERATE INVOICE</p>
            <p className="tFormName">{rowData?.generate_invoice}</p>
          </Grid> */}
        </Grid>
        <AgGridPaginatedTable
          getTableRows={getTransactionItemsData}
          columns={salesOrderItemsTable1}
          perPage={5}
          refreshCounter={0}
        />
      </Box>
    </>
  );
}
function Loading() {
  return (
    <Box
      display="flex"
      alignItems="center"
      justifyContent="center"
      sx={{ width: "100%", height: "100vh" }}
    >
      <Box textAlign="center">
        {/* <Typography variant="h3" fontWeight="600">
          Logging In ...
        </Typography>
        <br /> */}
        <CircularProgress />
      </Box>
    </Box>
  );
}
